<template>
    <div class="col-lg-6  mb-3" :class="{'chart-loading': loading}">
        <h3 class="mb-3"><b>Kết Quả Đánh Giá Tính Hiệu Lực BPKS</b></h3>
        <Chart type="bar" :data="bpksData" :options="basicOptions" :key="componentKey"/>
    </div>
</template>

<script>
import Chart from '@/components/Chart.vue';
export default {
    name: "chartBkps",
    props:{
        bpks: Object,
        loading: Boolean
    },
    components: {
        Chart
    },
    watch: {
        "$props.bpks"() {
            this.bpksData.labels = this.bpks?.dataChart?.label ?? [];
            this.bpksData.datasets[0].data = this.bpks?.dataChart?.active ?? [];
            this.bpksData.datasets[1].data = this.bpks?.dataChart?.unactive ?? [];
            this.bpksData.datasets[2].data = this.bpks?.dataChart?.total ?? [];
            this.componentKey++;
        }
    },
    data() {
        return {
            componentKey: 0,
            bpksData: {
                // labels: ['Cao', 'Trung bình', 'Thấp'],
                maxBarThickness: 6,
                datasets: [
                    {
                        label: 'Hiệu lực',
                        backgroundColor: '#3B7D22',
                        pointStyle: 'rect',
                        maxBarThickness: 32,
                        // data: [8,10,1]
                    },
                    {
                        label: 'Chưa hiệu lực',
                        backgroundColor: '#E97131',
                        pointStyle: 'rect',
                        maxBarThickness: 32,
                        // data: [5,13,5]
                    },
                    {
                        label: 'Tổng cộng',
                        backgroundColor: '#215E9A',
                        pointStyle: 'rect',
                        maxBarThickness: 32,
                        // data: [13,23,6]
                    }
                ]
            },
            basicOptions: {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: '#495057'
                        },
                        position: 'bottom'
                    },
                    datalabels: {
                        color: '#000000',
                        anchor: 'end',
                        align: 'end',
                        clamp: true,
                        formatter: function(value) {
                            return String(value).replace(/(.)(?=(\d{3})+$)/g, "$1,");
                        }
                    }
                }
            }
        }
    }
}
</script>